// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2n_U5","header":"MessagesList_header__1kk_p","chat":"MessagesList_chat__3Jjl_"};